<br><br><div class="container-fluid">
    <div class="row form-container" [@inOutAnimation] [style.width.px]="formContainerWidth" *ngxPermissionsOnly="['evaluacionWeb']">
        <div class="form-content col-md-6" *ngIf="enabled==1">
            <br>
            <div class="row">
                <div class="col-md-6">
                    <a *ngxPermissionsOnly="['evaluacionWeb']" class="btn-add" (click)="showDpiAlert()"><span class="img-add"><img src="../../assets/images/general/icon@2x.png" height="20px"></span> Agregar gestión</a>
                </div>
              <div class="col-md-12 ml-0 mr-0 p-0 mt-4">
                <pagination-controls
                  class="p-0 my-pagination"
                  previousLabel="Anterior"
                  nextLabel="Siguiente"
                  maxSize="6"
                  (pageChange)="p = $event"
                  (pageBoundsCorrection)="p = $event"
                ></pagination-controls>
              </div>
            </div>

            <div class="row" style="height: 700px; overflow-y: scroll;">
                <div class="col-md-12">
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <th>No.</th>
                                <th>Nombre completo</th>
                                <th>DPI</th>
                                <th>Canal</th>
                             </tr>
                        </thead>
                        <tbody style="width: 100% !important;">
                                <tr *ngFor="let item of precalificaiones |
                                  filter:term |
                                  paginate: {
                                    itemsPerPage: itemsPerPage,
                                    currentPage: p
                                  }"
                                  class="state_{{item.estadoColorPrecalificacion}}"
                                    (click)="setGestion(item)" style="width: 100%  !important;">
                                    <td>{{item.noPrecalificacion}}</td>
                                    <td *ngIf="item.participante[0].tipoParticipante=='DEUDOR'">{{item.participante[0].primerNombre}} {{item.participante[0].primerApellido}}</td>
                                    <td *ngIf="item.participante[0].tipoParticipante=='DEUDOR'">{{item.participante[0].dpi}}</td>
                                    <td *ngIf="item.participante[0].tipoParticipante=='CODEUDOR'">{{item.participante[1].nombreCompleto}}</td>
                                    <td *ngIf="item.participante[0].tipoParticipante=='CODEUDOR'">{{item.participante[1].dpi}}</td>
                                    <td >AB</td>
                                </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="form-open">
            <div class="btn-open" (click)="OpenClose()">
                <span *ngIf="enabled==1"><</span>
                <span *ngIf="enabled==0">></span>
            </div>
        </div>

    </div>

</div>

